import { shallowEqual, useSelector } from "react-redux";

const useGetSelectedPublication = ({ defaultUpfCourseId, isCurriculumOrCourseChanged = false, publications }) => {
  const selectedPublication = useSelector(state => state.UPFAssignReducer.selectedPublication, shallowEqual);

  if(isCurriculumOrCourseChanged) return { selectedPublication };
  
  for(const key in publications) {
    if(publications[key].courses.includes(defaultUpfCourseId)) {
	  return {
        selectedPublication: {
          value: publications[key].id,
          label: publications[key].name
	  } };
    }
  }

  return { selectedPublication };
}

export default useGetSelectedPublication;


// WEBPACK FOOTER //
// ./components/course-filters/hooks/use-get-selected-publication.js